import React from 'react';
import PropTypes from 'prop-types';
import pure from 'recompose/pure';
import Typography from '@material-ui/core/Typography';
import { getMonthRus, getDayRus } from '../common';

const sanitizeRestProps = ({
  addLabel,
  allowEmpty,
  basePath,
  cellClassName,
  className,
  formClassName,
  headerClassName,
  label,
  linkType,
  locale,
  record,
  resource,
  sortable,
  sortBy,
  source,
  textAlign,
  translateChoice,
  ...rest
}) => rest;

const TextField = ({
  className, source, record = {}, isDate = false, isShowDay = false, showYear = false, costilniiKostil = false, ...rest
}) => {
  if (record[source]) {
    const date = new Date(record[source]);
    const time = isDate ? `${date.getDate()} ${getMonthRus(date)}` : record[source].split(' ')[1].slice(0, -3);
    const day = getDayRus(date);
    if (costilniiKostil) {
      return (
        <Typography
          component="span"
          body1="body1"
          className={className}
          {...sanitizeRestProps(rest)}
        >
          {`${date.getDate()} ${getMonthRus(date)} ${time}`}
        </Typography>
      );
    }

    if (showYear) {
      return (
        <Typography
          component="span"
          body1="body1"
          className={className}
          {...sanitizeRestProps(rest)}
        >
          {`${date.getFullYear()} ${time}`}
        </Typography>
      );
    } else {

      return (
        <Typography
          component="span"
          body1="body1"
          className={className}
          {...sanitizeRestProps(rest)}
        >
          {isShowDay ? `${day} ${time}` : `${time}`}
        </Typography>
      );
    }
  }
  return null;
};

TextField.defaultProps = {
  isDate: false,
  showYear: false
};

TextField.propTypes = {
  addLabel: PropTypes.bool,
  basePath: PropTypes.string,
  className: PropTypes.string,
  cellClassName: PropTypes.string,
  headerClassName: PropTypes.string,
  label: PropTypes.string,
  record: PropTypes.object,
  sortBy: PropTypes.string,
  source: PropTypes.string.isRequired,
  isDate: PropTypes.bool,
  isShowDay: PropTypes.bool,
  showYear: PropTypes.bool,
  costilniiKostil: PropTypes.bool
};

const TextLabelWithDate = pure(TextField);

TextLabelWithDate.defaultProps = {
  addLabel: true,
  isShowDay: false
};

export default TextLabelWithDate;



// WEBPACK FOOTER //
// ./src/components/TextFieldWithDate.js